export default __webpack_public_path__ + "static/media/ru-cu.75ec6094.svg";